// src/components/filter/ContactList.js
import React, { useMemo, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as url from "../../helpers/common_helper";
import { formatNumber } from "../../helpers/language_helper";

//import components
import Breadcrumbs from "components/Common/Breadcrumb";
import DataTable from "../../components/Common/LocalizedDataTable";
import { ContactApi } from "apis/ContactApi";
import { useHistory, useLocation } from "react-router-dom";
import { withTranslation } from "react-i18next";
import config from "config/config";

function useQuery() {
  const { search } = useLocation();
  return useMemo(() => new URLSearchParams(search), [search]);
}

function ContactList(props) {
  let query = useQuery();
  const history = useHistory();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeData, setActiveData] = useState({
    page: 1,
    total: 1,
    search: "",
    limit: config.LIMIT,
  });

  useEffect(() => {
    getAllContactList(activeData);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getAllContactList({ ...activeData });
    // eslint-disable-next-line
  }, [query]);

  const columns = [
    {
      name: props.t("Sr.No"),
      selector: (row) => row.sr_no,
      cell: (row) => formatNumber(row.sr_no),
      sortable: false,
    },
    {
      name: props.t("Name"),
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: props.t("Email"),
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: props.t("Phone No"),
      selector: (row) => row.phone_no,
    },
    // {
    //   name: props.t("Subject"),
    //   selector: (row) => row.subject,
    // },
    {
      name: props.t("Action"),
      selector: (row) => row.action,
    },
  ];

  const getAllContactList = (params) => {
    setLoading(true);
    ContactApi.getAllContactList({ ...params })
      .then((res) => {
        setActiveData({
          page: params.page,
          total: res.data.data.total, // ✅ fixed from count → total
          search: params.search,
          limit: params.limit,
        });

        let formattedData = [];
        res?.data?.data?.contactus?.forEach((v, i) => {
          formattedData[i] = {
            sr_no: ((params.page || 1) - 1) * (params.limit || 10) + (i + 1),
            id: v.id,
            name: v.name || "-",
            email: v.email || "-",
            address: v.address|| "-",
            phone_no: v.phone_no|| "-",
            // subject: v.subject|| "-",
            message: v.message|| "-",
            action: (
              <>
                <button
                  className="btn btn-sm btn-link"
                  onClick={() => history.push(`/view-contact/${v.id}`)}
                >
                  <i
                    className="fas fa-eye"
                    title={props.t("View")}
                    style={{ color: v.active === "Y" || "green" }}
                  ></i>
                </button>
              </>
            ),
          };
        });

        setData(formattedData);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleChange = (page) => {
    const params = {
      ...activeData,
      page,
    };
    setActiveData(params);
    getAllContactList(params);
  };

  const handleRowChange = (limit) => {
    const params = {
      ...activeData,
      page: 1, // reset page when limit changes
      limit,
    };
    setActiveData(params);
    getAllContactList(params);
  };

  //meta title
  document.title = props.t("User Enquiries") + " | " + props.t("Salon");

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Breadcrumbs
          title={props.t("User Enquiries")}
          breadcrumbItem={props.t("User Enquiries")}
        />
      </div>

      <div className="container-fluid">
        <DataTable
          className="table-bordered"
          progressPending={loading}
          columns={columns}
          data={data}
          pagination
          paginationServer
          paginationTotalRows={activeData.total}
          paginationPerPage={activeData.limit}
          onChangeRowsPerPage={handleRowChange}
          onChangePage={handleChange}
          noHeader
          defaultSortField="id"
          defaultSortAsc={false}
          highlightOnHover
        />
      </div>
    </div>
  );
}

ContactList.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(ContactList);
